import type {SVGProps} from 'react'
const SvgListLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g stroke="#788492" strokeLinecap="round">
      <path d="M22 12H2M22 7H2M22 17H2" />
    </g>
  </svg>
)
export default SvgListLarge
